// import dataProvider from './DataProvider';
import {Auth} from '../AuthProvider';
import querystring from 'query-string';
import axios from 'axios';
import { getCurrentArea } from '../../../common/area';

import config from "./../../../config";

const getApiUrl = () => {
    const area = getCurrentArea();
    return config.apiV4[area]?.URL || config.apiV4.user.URL;
};

const apiUrl = getApiUrl();

export function getList (resource, qsFilter) {
    return new Promise((resolve, reject) => {      
        let qs = '';
        if (qsFilter && qsFilter.length > 0) {
            qs = qsFilter.map(f => `${f.key}=${encodeURIComponent(f.value)}`).join('&');
        }
        const url = `${apiUrl}${resource}${qs ? '?' + qs : ''}`;

        axios.get(url, {
                withCredentials: true, 
                withXSRFToken:true, 
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    }
                }
        ).then(res => {
            resolve(res)
        })
        .catch(err => {
            if (err.response?.status === 401) {
                Auth.redirectToLogin()
            }
            if (err.response?.status === 500) {
                reject(err.response.data)
            }
            reject(err)
        })
    });
}


export function getOne (resource, id) {
    return new Promise((resolve, reject) => {
        axios.get(`${apiUrl}${resource}${id}`, {
                withCredentials: true, 
                withXSRFToken:true, 
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    }
        }).then(res => {
            resolve(res)
        }).catch(err => {
            if (err.response.status === 401) {
                Auth.redirectToLogin()
            }
            if (err.response.status === 402) {
    //            Auth.redirectToPayment()
            }
            if (err.response.status === 404) {
                reject(err.response.data)
            }
            reject(err)
        })
    });
}

export function update (resource, id, params) {
    return new Promise((resolve, reject) => {
        let url = `${apiUrl}${resource}`;
        if (id) {
            url = `${apiUrl}${resource}${id}`;
        }
        const isFormData = params.data instanceof FormData;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
        };
        
        // Don't set Content-Type for FormData, let browser set it with boundary
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }
        
        // For FormData with PUT, use POST with _method=PUT (Laravel method spoofing)
        // This is necessary because many browsers/servers don't handle PUT with FormData correctly
        if (isFormData) {
            params.data.append('_method', 'PUT');
            axios.post(url, params.data, {
                    withCredentials: true, 
                    withXSRFToken:true, 
                    headers: headers
            }).then(res => {
                resolve(res)
            }).catch(err => {
                if (err.response && err.response.status === 401) {
                    Auth.redirectToLogin()
                }
                if (err.response && err.response.status === 422) {
                    reject(err.response.data);
                }
                if (err.response && err.response.status === 405) {
                    reject(err.response.data);
                }
                if (err.response && err.response.status === 403) {
                    reject(err.response.data);
                }
                reject(err);
            });
        } else {
            axios.put(url, params.data, {
                    withCredentials: true, 
                    withXSRFToken:true, 
                    headers: headers
            }).then(res => {
                resolve(res)
            }).catch(err => {
                if (err.response && err.response.status === 401) {
                    Auth.redirectToLogin()
                }
                if (err.response && err.response.status === 422) {
                    reject(err.response.data);
                }
                if (err.response && err.response.status === 405) {
                    reject(err.response.data);
                }
                if (err.response && err.response.status === 403) {
                    reject(err.response.data);
                }
                reject(err);
            });
        }
    });
}

export function create (resource, params, props) {
    return new Promise((resolve, reject) => {
        const isFormData = params.data instanceof FormData;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
        };
        
        // Don't set Content-Type for FormData, let browser set it with boundary
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }
        
        axios.post(`${apiUrl}${resource}`, params.data, {
                withCredentials: true, 
                withXSRFToken:true, 
                headers: headers
        }).then(res => {
            resolve(res)
        }).catch(err => {
            if (err.response && err.response.status === 401) {
                Auth.redirectToLogin()
            }
            if (err.response && err.response.status === 405) {
                reject(err.response.data);
            }
            if (err.response && err.response.status === 422) {
                reject(err.response.data);
            }
            reject(err);
        });
    });
}

export function deleteOne (resource, id) {
    return new Promise((resolve, reject) => {
        axios.delete(`${apiUrl}${resource}/${id}`, {
                withCredentials: true, 
                withXSRFToken:true, 
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    }
        }).then(res => {
            resolve(res)
        }).catch(err => {
            if (err.response.status === 405) {
                reject(err.response.data);
            }
            if (err.response.status === 400) {
                reject(err.response.data);
            }
            if (err.response.status === 422) {
                reject(err.response.data);
            }
            reject(err)
        });
    });
}